import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Row,
  Col,
  Label,
  Button,
  Form,
} from "reactstrap";
import {
  Link
} from "react-router-dom";
import { AccountLogoSize } from "settings/shared/constants"
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Select from "react-dropdown-select";
import { validEmailRegex, PASSWORD_REGEXP, LogoErrorMessageDimension, LogoErrorMessageMin } from '../../settings/shared/constants'
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay'
import ScaleLoader from "react-spinners/ScaleLoader";
import SuperAdminService from "../../services/api/SuperAdmin";
import { Scrollbars } from 'react-custom-scrollbars';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import defaultImage from "assets/img/logo_default.png";
import { LogoHeight, LogoWidth } from "../../settings/shared/constants";


const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }
}


class NewAccount extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      errorSubmitted: false,
      errorMessage: '',
      editId: '',
      name: "",
      email: "",
      password: '',
      url: "",
      officeAddress: "",
      description: "",
      city: "",
      tenantOptions: [],
      accountType: 'NEW',
      btnActions: "Create",
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      hours: 10,
      file: null,
      imagePreviewUrl: defaultImage,
      isLogo:false
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);

  }
  componentDidMount() {
    let mode = this.props.location.state.mode;
    mode === "edit" ?
      this.EditParticularTenant(this.props.location.state.editId)
      :
      this.setState({
        editId: ""
      })
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.getTenantList();
  }

  getTenantList = () => {
    var tenantoption = [];
    SuperAdminService.getTenantType()
      .then((response) => {
        //if (response.status === 'SUCCESS') {
        let TenantTypeData = response.tenantType;
        for (let a = 0; a < TenantTypeData.length; a++) {
          tenantoption.push({
            label: TenantTypeData[a],
            value: TenantTypeData[a],
          })
        }
        this.setState({ tenantOptions: tenantoption, loading: false })
        //} 
        // else {
        //   this.setState({ loading:false });
        //   toast.error(response.errorMessage);
        // }
      }).catch((error) => {
        this.setState({ loading: false });
      })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }

  EditParticularTenant(id) {
    this.setState({
      loading: true,
      btnActions: "Update",
      editId: id,
    });
    SuperAdminService.getParticularTenant(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let TenantData = response.organisationDTOS;
          this.setState({
            name: TenantData[0].name,
            tenantid: TenantData[0].tenantIdentifier,
            email: TenantData[0].email,
            url: TenantData[0].url,
            firstName: TenantData[0].firstName,
            lastName: TenantData[0].lastName,
            accountType: TenantData[0].accountType,
            phoneNumber: TenantData[0].phoneNumber,
            hours: TenantData[0].hours/60,
            // logo:TenantData[0].logo,
            imagePreviewUrl: TenantData[0].logo === null ? defaultImage : TenantData[0].logo,
            loading: false
          })

        } else {
          this.setState({ loading: false });
          toast.error(response.errorMessage);
        }
      }).catch((error) => {
        this.setState({ loading: false });
      })
  }

  setErrorMessage(message) {
    if (message === "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    switch (name) {
      case 'password':
        if (PASSWORD_REGEXP.test(value)) {
          this.setState({
            passswordChecker: "strong"
          })
        }
        else if (value.length === 0 || value === undefined) {
          this.setState({
            passswordChecker: "poor"
          })
        }
        else if (value.length === 6) {
          this.setState({
            passswordChecker: "weak"
          })
        }
        else if (value.length === 7) {
          this.setState({
            passswordChecker: "medium"
          })
        }
      break;
      default:
        break;
    }
    this.setState({ [name]: value });
  }
  handleChangeTenant = (event) => {
    // console.log('EVENT',event.length)
    if (event === undefined || event.length === 0) {
      this.setState({
        accountType: "NEW"
      });
    } else {
      this.setState({
        accountType: event[0].value
      });
    }
  }
  nospecialChar(event) {
    event.preventDefault();

    var regex = /^[A-Za-z0-9 ]+$/;
    const { name, value } = event.target;
    this.setState({ [name]: value});

    var content = event.target.value;
    var isAlpha = !/[^a-zA-Z]/.test(content.charAt(0))
    var isValid = regex.test(content);
    if(isAlpha){
    if (!isValid) {
        this.setErrorMessage("Special characters are not allowed.");
    } else {
      this.setErrorMessage("");
    }
    this.setState({ [name]: value});
    return isValid;
  }
  else{
    this.setErrorMessage("Start with Alphabet.");
  }
  }
  typeUrl(e) {
    var type = this.state.url;
    type = e.target.value;
    try {
      new URL(type);
      this.setErrorMessage("");
      this.setState({notvalidurl:false})
    } catch (_) {
      this.setErrorMessage("Please Enter valid url");
      this.setState({notvalidurl:true})

    }
    this.setState({ url: type });
  }
  // Submit New Tenant Data
  CreateNewTenant = (event) => {
    event.preventDefault();
    var regex = /^[A-Za-z0-9 ]+$/;
    var isAlpha = !/[^a-zA-Z]/.test(this.state.name.charAt(0))
    if (this.state.editId !== "") {
      if ((this.state.name === "" || this.state.name === undefined)) {
        this.setErrorMessage("Please Enter Tenant Name");
      } else if(!/[^a-zA-Z]/.test(this.state.name.charAt(0)) === false){
        this.setErrorMessage("Tenant Name should start with alphabet");
      }  else if(regex.test(this.state.name) === false){
        this.setErrorMessage("Special characters are not allowed.");
      } else if ((this.state.email === "" || this.state.email === undefined)) {
        this.setErrorMessage("Please Enter Email");
      } else if (!validEmailRegex.test(this.state.email)) {
        this.setErrorMessage("Please Enter Valid Email Id");
      }  else if ((this.state.firstName === "" || this.state.firstName === undefined)) {
        this.setErrorMessage("Please Enter First Name");
      }  else if(!/[^a-zA-Z]/.test(this.state.firstName.charAt(0)) === false){
        this.setErrorMessage("First Name should start with alphabet");
      } else if(regex.test(this.state.firstName) === false){
        this.setErrorMessage("Special characters are not allowed in first name.");
      } else if ((this.state.accountType === "" || this.state.accountType === undefined)) {
        this.setErrorMessage("Please Select Account Type");
      }else if ((this.state.notvalidurl === true)) {
        this.setErrorMessage("Please Enter valid url");
      } 
      else {
           this.PostConnection();
      }
    }
    else {
      if ((this.state.name === "" || this.state.name === undefined)) {
        this.setErrorMessage("Please Enter Tenant Name");
      } else if(!/[^a-zA-Z]/.test(this.state.name.charAt(0)) === false){
        this.setErrorMessage("Tenant Name should start with alphabet");
      } else if(regex.test(this.state.name) === false){
        this.setErrorMessage("Special characters are not allowed in tenant name.");
      } else if ((this.state.email === "" || this.state.email === undefined)) {
        this.setErrorMessage("Please Enter Email");
      } else if (!validEmailRegex.test(this.state.email)) {
        this.setErrorMessage("Please Enter Valid Email Id");
      } else if ((this.state.firstName === "" || this.state.firstName === undefined)) {
        this.setErrorMessage("Please Enter First Name");
      } else if(!/[^a-zA-Z]/.test(this.state.firstName.charAt(0)) === false){
        this.setErrorMessage("First Name should start with alphabet");
      } else if(regex.test(this.state.firstName) === false){
        this.setErrorMessage("Special characters are not allowed in first name.");
      } else if ((this.state.accountType === "" || this.state.accountType === undefined)) {
        this.setErrorMessage("Please Select Account Type");
      } else if ((this.state.notvalidurl === true)) {
        this.setErrorMessage("Please Enter valid url");  
      } else {
           this.PostConnection();
      }

    }

  }

  PostConnection = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let post = {
        name: this.state.name,
        id: this.state.tenantid,
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        accountType: this.state.accountType,
        phoneNumber: this.state.phoneNumber,
        hours: this.state.accountType === "NEW" ? this.state.hours * 60 : 0,
        logo: this.state.isLogo ? this.state.imagePreviewUrl : null,
        url: this.state.url,
      }
      // console.log("POST",post)
      if (this.state.editId !== "") {
        SuperAdminService.UpdateTenantData(this.state.editId, post)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Tenant Updated Successfully!</b></i>);
              this.props.history.push('/accounts');
              this.clearformData();   // Reset Form data    
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
              // this.setErrorMessage("Error in Creating Connector");
            }
          }
          );
      } else {
        SuperAdminService.PostTenant(post)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Tenant Created Successfully!</b></i>);
              this.props.history.push('/accounts');
              this.clearformData();   // Reset Form data    
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
              // this.setErrorMessage("Error in Creating Connector");
            }
          }
          );
      }
    } else {
      console.error('Invalid Form')
    }
  }

  cancelClick = () => {
    this.props.history.push('/accounts');
  }

  handleImageChange(e) {
    e.preventDefault();
    this.setState({
      isLogo: true
    })
    let reader = new FileReader();
    let file = e.target.files[0];
    if(Math.round(file.size / 1024) > (AccountLogoSize * 1024)  ) {
      this.setErrorMessage("please upload file size " + AccountLogoSize + " MB or less");
    } else {
      reader.onloadend = () => {
          var image = new Image();
          image.src = reader.result;
          image.onload = () => {
              if (image.width === LogoWidth && image.height === LogoHeight) {
                  this.setState({
                      file: file,
                      imagePreviewUrl: reader.result
                  });
              } else {
                  this.setErrorMessage(`Logo dimensions should be : Width-${LogoWidth} px & Height-${LogoHeight} px`)
              }
          }

      };
  }
  reader.readAsDataURL(file);
  }
  // Reset form data
  clearformData() {
    this.setState({
      errorSubmitted: false,
      errorMessage: '',
      editId: '',
      name: "",
      email: "",
      url: "",
      officeAddress: "",
      description: "",
      city: "",
      btnActions: "Create",
    })
  }


  render() {
    return (

      <>
        <PanelHeader
          content={
            <div className="header text-center">

            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Col xs={12} md={12}>
              <Row>
                <div className=" col" id="errorDiv">
                  <Card className=" shadow">
                    <CardHeader className=" bg-transparent">
                      {/* <h3 className=" mb-0">List of NewRun</h3>
                  <h3 className=" mb-0">Add New</h3> */}

                      <Row className="align-items-center">
                        <div className="col">
                          {this.state.editId === "" && <h5 className="mb-0">New Account</h5>}
                          {this.state.editId !== "" && <h5 className="mb-0">Edit Account</h5>}
                        </div>
                        <div className="col text-right">
                          <Link to="accounts" >
                            <span className="close clear-filter">×</span>
                          </Link>

                        </div>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <div className="carcontent">
                        {this.state.errorSubmitted &&
                          <div style={styles.errorBox}>
                            <span style={styles.error}>{this.state.errorMessage}</span>
                          </div>
                        }
                        <Card>
                          <CardBody>
                            <div className="carcontent">
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight - 220}>
                                <Form role="form" noValidate onSubmit={this.CreateNewTenant}>

                                  <Row className="mt-12" style={{ paddingRight: 10 }}>
                                    <Col className="mb-12 mb-xl-0" xl="12">
                                      <Row className="icon-examples" style={{ marginTop: 10 }}>
                                        <Col lg="4">
                                          <Label md="5"> Tenant Name * </Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Tenant Name"
                                              name="name"
                                              value={this.state.name || ""}
                                              type="text"
                                              onChange={e => this.nospecialChar(e)} />

                                          </FormGroup>
                                        </Col>
                                        {/* {this.state.editId !== "" &&
                        <Col lg="4">
                      <Label md="5"> Tenant Id * </Label>
                          <FormGroup>
                            <Input
                          className="form-control"
                          placeholder="Tenant Id"
                          name="tenantid"
                          value={this.state.tenantid || ""}
                          type="text"
                          disabled
                          onChange={this.handleChange}/>
                          </FormGroup>
                        </Col>  } */}
                                        <Col lg="4">
                                          <Label md="5">Primary Email *</Label>
                                          <FormGroup> <Input
                                            className="form-control"
                                            placeholder="Email"
                                            name="email"
                                            value={this.state.email || ""}
                                            type="text"
                                            onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>  
                                        <Col lg="4">
                                          <Label md="4">First Name *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="First Name"
                                              name="firstName"
                                              value={this.state.firstName || ""}
                                              type="text"
                                              onChange={e => this.nospecialChar(e)} />
                                          </FormGroup>
                                        </Col>

                                        <Col lg="4">
                                          <Label md="4">Last Name </Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Last Name"
                                              name="lastName"
                                              value={this.state.lastName || ""}
                                              type="text"
                                              onChange={e => this.nospecialChar(e)} />
                                          </FormGroup>
                                        </Col>
                                        <Col lg="4">
                                          <Label md="5"> Account Type *</Label>
                                          <FormGroup>
                                            <Select name="tenant" values={this.state.tenantOptions.filter(item => item.value === this.state.accountType)} className="form-control"
                                              options={this.state.tenantOptions} onChange={this.handleChangeTenant} noValidate />
                                          </FormGroup>
                                        </Col>
                                        <Col lg="4">
                                          <Label md="5"> Phone Number </Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Phone Number"
                                              name="phoneNumber"
                                              value={this.state.phoneNumber || ""}
                                              type="number"
                                              onChange={this.handleChange}
                                              onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            />
                                          </FormGroup>
                                        </Col>
                                        <br></br>
                                        <Col lg="4">
                                          <Label md="10"> Logo</Label>
                                          <FormGroup className='setting-form'>
                                            <img
                                              src={this.state.imagePreviewUrl}
                                              className="logo-account avatar-sm rounded-circle fit-image"
                                              alt="..."
                                            />
                                            <input type="file" className="upload" onChange={e => this.handleImageChange(e)} />
                                          </FormGroup>
                                          <div className='logo-dimension'>* {LogoErrorMessageMin} </div>
                                          <div className='logo-dimension'>* {LogoErrorMessageDimension}</div>
                                        </Col>
                                        {this.state.accountType === "NEW" &&
                                          <Col lg="4">
                                            <Label md="5"> Free Credits (in hrs) </Label>
                                            <FormGroup>
                                              {/* <RangeSlider
            value={this.state.hours || ""}
            onChange={e => this.setState({hours:e.target.value})}
            tooltipLabel={currentValue => `${currentValue} hrs`}
            min={0}
            max={10}
            step={1}
            variant='primary'
            tooltip='on'
          /> */}
                                              <Input
                                                className="form-control"
                                                placeholder="Free Credits"
                                                min="0"
                                                name="hours"
                                                value={this.state.hours || ""}
                                                type="number"
                                                // onChange={e => this.setState({hours:e.target.value})}
                                                onChange={(e) => {
                                                  let val = parseInt(e.target.value, 10);
                                                  if (isNaN(val)) {
                                                    this.setState({ hours: "" });
                                                  } else {
                                                    val = val >= 0 ? val : 0;
                                                    this.setState({ hours: val });
                                                  }
                                                }}
                                                onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                              />
                                            </FormGroup>
                                          </Col>
                                        } <Col lg="4">
                                          <Label md="5"> URL</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Url"
                                              name="url"
                                              value={this.state.url || ""}
                                              type="text"
                                              onChange={e => this.typeUrl(e)} />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                        
                                    </Col>  
                                  </Row>
                                  <hr />
                                  <Row className="logo-stickybuttons">
                                    <Col xs="1" className="logo-btn mr-5">
                                      <FormGroup>
                                        <Button
                                          color="secondary"
                                          size="sm"
                                          type="submit"
                                          onClick={this.cancelClick}
                                        >
                                          Cancel
                     </Button>
                                      </FormGroup>
                                    </Col>
                                    <Col xs="1" className ="logo-btn mr-1">
                                      <FormGroup>
                                        <Button
                                          color="primary"
                                          size="sm"
                                          type="submit"
                                        //  onClick={this.CreateNewTenant}
                                        >
                                          {this.state.btnActions}
                                        </Button>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </Form>
                              </Scrollbars>
                            </div>
                          </CardBody>
                        </Card>



                      </div>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Col>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default NewAccount;
